type ObservationOption = Record<
  string,
  {
    display: string;
    units?: string[];
    components?: { code?: string; display?: string; units: string[] }[][];
  }
>;

export const ALL_OBSERVATION_OPTIONS_MAP: ObservationOption = {
  'blood-pressure': {
    display: 'Blood Pressure',
    components: [
      [
        { code: 'systolic', display: 'Systolic', units: ['mmHg'] },
        { code: 'diastolic', display: 'Diastolic', units: ['mmHg'] },
      ],
    ],
  },
  'blood-sugar': { display: 'Blood Sugar', units: ['mmol/L', 'mg/dL'] },
  'heart-rate': { display: 'Heart Rate', units: ['bpm'] },
  'body-height': {
    display: 'Body Height',
    components: [
      [{ code: 'body-height', display: 'Height (m)', units: ['m'] }],
      [
        { code: 'height-ft', display: 'Height (ft)', units: ['ft'] },
        { code: 'height-in', display: 'Height (in)', units: ['in'] },
      ],
    ],
  },
  'oxygen-saturation': { display: 'Oxygen Saturation', units: ['%'] },
  pain: { display: 'Pain' },
  respiration: {
    display: 'Respiratory Rate',
    units: ['Breaths Per Minute (bpm)'],
  },
  temperature: { display: 'Temperature', units: ['Celsius', 'Farenheit'] },
  'body-weight': { display: 'Body Weight', units: ['kg', 'lb'] },
  'body-mass-index': { display: 'Body Mass Index' },
  'muscle-mass': { display: 'Body Muscle Mass', units: ['kg', 'lb'] },
  'body-fat-percentage': { display: 'Body Fat %', units: ['%'] },
  'body-waist-height': { display: 'Waist-Height Ratio' },
  'body-waist-hip': { display: 'Waist-Hip Ratio' },
  'average-heart-rate': { display: 'Avg Heart Rate', units: ['bpm'] },
  'energy-burned': { display: 'Energy Burned', units: ['kcal', 'kJ'] },
  'resting-heart-rate': { display: 'Resting Heart Rate', units: ['bpm'] },
};

const getFilteredTypes = (typesArray: string[]) =>
  Object.fromEntries(
    Object.entries(ALL_OBSERVATION_OPTIONS_MAP).filter(([key]) =>
      typesArray.includes(key)
    )
  );

const getCodeOptions = (object: ObservationOption) =>
  Object.entries(object).map(([key, value]) => ({ k: key, v: value.display }));

// Vital signs observations
const vitalSignTypes = [
  'blood-pressure',
  'heart-rate',
  'oxygen-saturation',
  'pain',
  'respiration',
  'temperature',
];
export const VITAL_SIGN_OPTIONS_MAP = getFilteredTypes(vitalSignTypes);
export const VITAL_SIGN_CODE_OPTIONS = getCodeOptions(VITAL_SIGN_OPTIONS_MAP);

// Body observations
const bodyTypes = [
  'blood-sugar',
  'body-height',
  'body-weight',
  'body-mass-index',
  'muscle-mass',
  'body-fat-percentage',
  'body-waist-height',
  'body-waist-hip',
];
export const BODY_OBSERVATION_OPTIONS_MAP = getFilteredTypes(bodyTypes);
export const BODY_OBSERVATION_CODE_OPTIONS = getCodeOptions(
  BODY_OBSERVATION_OPTIONS_MAP
);

// Manual entry fitness metrics — for alert testing on dev/staging only
const manualEntryFitnessTypes = [
  'average-heart-rate',
  'energy-burned',
  'resting-heart-rate',
];
export const MANUAL_ENTRY_FITNESS_OPTIONS_MAP = getFilteredTypes(
  manualEntryFitnessTypes
);
export const MANUAL_ENTRY_FITNESS_CODE_OPTIONS = getCodeOptions(
  MANUAL_ENTRY_FITNESS_OPTIONS_MAP
);
